module.exports = __webpack_public_path__ + "static/media/kern.8e8d44cb.png";